import { render, staticRenderFns } from "./exhibitionProfile.vue?vue&type=template&id=24fd33bc&scoped=true&"
import script from "./exhibitionProfile.vue?vue&type=script&lang=js&"
export * from "./exhibitionProfile.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionProfile.vue?vue&type=style&index=0&id=24fd33bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd33bc",
  null
  
)

export default component.exports